import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import DOMPurify from 'dompurify';
import { TrustedTypePolicyFactory } from 'trusted-types';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

declare global {
    interface Window {
        trustedTypes?: TrustedTypePolicyFactory;
    }
}

if (window.trustedTypes) {
    // Define a TrustedHTML policy
    window.trustedTypes.createPolicy('default', {
        createHTML: input => DOMPurify.sanitize(input),
        createScriptURL: url => url
    });
}

if (environment.production) {
    enableProdMode();
}

// Log what enviroment is running on start up.
console.log(`Environment: ${environment.environmentType}`);

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
